import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

/**
 * Gọi API lấy danh sách tay nắm cửa
 * @param {Object} values Tham số truyền vào
 * @param {number} values.product_type Loại sản phẩm
 * @param {number} values.door_type Loại cửa
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 */
export const fetchDoorHandles = createAsyncThunk(
  'get/modules/v3/door-and-handles',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: `modules/v3/door-and-handles`,
        method: 'get',
        // params: values,
        params: { ...values, country_code: process.env.REACT_APP_COUNTRY_CODE },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return { error: error.message };
    }
  }
);

/**
 * Gọi API lấy danh sách giá trị lọc của cửa (value/label)
 * @param {Object} [values] Tham số truyền vào
 * @param {'opening_type'|'orientation'|'door_style'|'door_coverage'} [values.field='orientation'] Trường cần lấy danh sách giá trị
 * @param {'vn'|'us'} [values.country_code] Quốc gia để lọc theo cờ vn/us của Door (mặc định theo REACT_APP_COUNTRY_CODE)
 */
export const fetchGroupDoor = createAsyncThunk(
  'get/modules/v3/door-groups',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: `modules/v3/door-groups`,
        method: 'get',
        params: {
          field: values?.field ?? 'orientation',
          country_code:
            values?.country_code ?? process.env.REACT_APP_COUNTRY_CODE ?? 'vn',
        },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return { error: error.message };
    }
  }
);
